import { useCallback, useState } from 'react'
import PlayIcon from '../assets/landing/play-icon.svg?react'
import videoThumbnail from '../assets/landing/video-thumbnail.png'

const YOUTUBE_VIDEO_ID = 'xYhEvqhHkBw'
const YOUTUBE_EMBED_URL = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0&controls=0&fs=0`

export default function EaseOfUseSection() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false)

  const handlePlayClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault()
      setIsVideoPlaying(true)
    },
    [setIsVideoPlaying],
  )

  return (
    <section className='px-4 py-10 space-y-6 bg-[#FEFBE9]'>
      <div className='text-center space-y-2'>
        <h2 className='text-2xl font-semibold text-gray-12 mb-6'>
          かんたん設定で
          <br />
          すぐに思い出が届き始めます
        </h2>
        <p className='text-base text-gray-12 text-left font-normal leading-[160%] tracking-0'>
          フォトフレームに表示されたQRコードを読み込むだけで自動的にみてねとつながり、すぐに写真や動画がフレームに届きはじめます。
          <br />
          ※ご利用にはWi-Fiが必要です
        </p>
      </div>

      <div className='relative max-w-md mx-auto rounded-lg overflow-hidden'>
        {!isVideoPlaying ? (
          <>
            <img src={videoThumbnail} alt='' className='w-full rounded-lg' loading='lazy' />
            <button
              onClick={handlePlayClick}
              className='absolute inset-0 flex items-center justify-center rounded-lg transition-colors hover:bg-black/10'
              aria-label='Play video'
            >
              <PlayIcon className='w-14 h-14' />
            </button>
          </>
        ) : (
          <div className='relative w-full' style={{ paddingBottom: '56.25%' }}>
            <iframe
              className='absolute top-0 left-0 w-full h-full rounded-lg'
              src={YOUTUBE_EMBED_URL}
              title='かんたん設定で すぐに思い出が届き始めます'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              allowFullScreen={true}
            />
          </div>
        )}
      </div>
    </section>
  )
}
